import { render, staticRenderFns } from "./ServiceList.vue?vue&type=template&id=ae45e576&scoped=true"
import script from "./ServiceList.vue?vue&type=script&lang=js"
export * from "./ServiceList.vue?vue&type=script&lang=js"
import style0 from "./ServiceList.vue?vue&type=style&index=0&id=ae45e576&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae45e576",
  null
  
)

export default component.exports